package io.jsonize.web

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import io.jsonize.web.components.HtmlHistoryOverlayBridge
import io.jsonize.web.components.AdBanner
import io.jsonize.web.components.showHistoryOverlay
import io.jsonize.web.components.Toolbar
import io.jsonize.web.navigation.NavController
import io.jsonize.web.navigation.NavigationGraph
import io.jsonize.web.screens.editor.EditorPanel
import io.jsonize.web.theme.AppTheme
import io.jsonize.web.theme.JsonTheme
import io.jsonize.web.theme.LocalThemeIsDark
import io.jsonize.web.viewmodel.AppViewModel
import kotlinx.browser.document

@Preview
@Composable
fun App(
    nav: NavController = NavController(),
    vm: AppViewModel = AppViewModel()
) = AppTheme(onThemeChanged = {}) {
    val isDarkState = LocalThemeIsDark.current
    val isDark by isDarkState
    val editorPanelState = remember { mutableStateOf(EditorPanel.Editor) }
    val lastContentPanelState = remember { mutableStateOf(EditorPanel.Editor) }
    JsonTheme(isDark) {
        LaunchedEffect(isDark) {
            document.documentElement?.setAttribute("data-theme", if (isDark) "dark" else "light")
        }
        HtmlHistoryOverlayBridge(
            viewModel = vm,
            onDismiss = { editorPanelState.value = lastContentPanelState.value }
        )
        Column(Modifier.fillMaxSize()) {
            Toolbar(
                isDark,
                onHistoryClick = {
                    editorPanelState.value = EditorPanel.History
                    showHistoryOverlay()
                },
                onThemeToggle = { isDarkState.value = !isDarkState.value }
            )
            AdBanner()
            NavigationGraph(nav, vm, editorPanelState, lastContentPanelState)
        }
    }
}

/*@Preview
@Composable
fun App(
    onThemeChanged: @Composable (isDark: Boolean) -> Unit = {}
) = AppTheme(onThemeChanged) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .windowInsetsPadding(WindowInsets.safeDrawing)
            .padding(16.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = stringResource(Res.string.cyclone),
            fontFamily = FontFamily(Font(Res.font.IndieFlower_Regular)),
            style = MaterialTheme.typography.displayLarge
        )

        var isRotating by remember { mutableStateOf(false) }

        val rotate = remember { Animatable(0f) }
        val target = 360f
        if (isRotating) {
            LaunchedEffect(Unit) {
                while (isActive) {
                    val remaining = (target - rotate.value) / target
                    rotate.animateTo(target, animationSpec = tween((1_000 * remaining).toInt(), easing = LinearEasing))
                    rotate.snapTo(0f)
                }
            }
        }

        Image(
            modifier = Modifier
                .size(250.dp)
                .padding(16.dp)
                .run { rotate(rotate.value) },
            imageVector = vectorResource(Res.drawable.ic_cyclone),
            colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.onSurface),
            contentDescription = null
        )

        ElevatedButton(
            modifier = Modifier
                .padding(horizontal = 8.dp, vertical = 4.dp)
                .widthIn(min = 200.dp),
            onClick = { isRotating = !isRotating },
            content = {
                Icon(vectorResource(Res.drawable.ic_rotate_right), contentDescription = null)
                Spacer(Modifier.size(ButtonDefaults.IconSpacing))
                Text(
                    stringResource(if (isRotating) Res.string.stop else Res.string.run)
                )
            }
        )

        var isDark by LocalThemeIsDark.current
        val icon = remember(isDark) {
            if (isDark) Res.drawable.ic_light_mode
            else Res.drawable.ic_dark_mode
        }

        ElevatedButton(
            modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp).widthIn(min = 200.dp),
            onClick = { isDark = !isDark },
            content = {
                Icon(vectorResource(icon), contentDescription = null)
                Spacer(Modifier.size(ButtonDefaults.IconSpacing))
                Text(stringResource(Res.string.theme))
            }
        )

        val uriHandler = LocalUriHandler.current
        TextButton(
            modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp).widthIn(min = 200.dp),
            onClick = { uriHandler.openUri("https://github.com/terrakok") },
        ) {
            Text(stringResource(Res.string.open_github))
        }
    }
}*/
